import React, { Fragment, useState, useEffect } from 'react'
import { Table, Form, Row, Col, InputGroup, Container, Button } from 'react-bootstrap'
import Select from 'react-select'
import CurrencyInput from 'react-currency-input'
import { registerLocale } from 'react-datepicker'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import 'react-datepicker/dist/react-datepicker.css'
import ptBr from 'date-fns/locale/pt-BR'
import moment from 'moment'

import { formatMoney, handleDecimalConvert, formatFromMoney } from '../../../utils/string.utils'
import { gerarParcelasPagamento } from '../../../utils/parcelamento.utils'
import { parcelasSelect } from '../../../constants/agendamento.constants'

registerLocale('pt-BR', ptBr)

export default function Parcelamento(props) {
  const {
    setPagamento,
    previousStep,
    handlePlanoPagamento,
    pagamento,
    isPlanoBalao,
    dataVencimentoPrimeiraParcela,
    setDataVencimentoPrimeiraParcela,
  } = props

  const [totalPagamento, setTotalPagamento] = useState(pagamento ? pagamento.valorTotal : 0)
  const [valorEntrada, setValorEntrada] = useState('0.0')
  const valorParcelamento = handleDecimalConvert(totalPagamento) / parcelasSelect[0].value
  const [parcelamentoSelecionado, setParcelamentoSelecionado] = useState(parcelasSelect[0])
  const [parcelas, setParcelas] = useState([])
  const [dataVencimento, setDataVencimento] = useState(
    dataVencimentoPrimeiraParcela
      ? dataVencimentoPrimeiraParcela._isAMomentObject
        ? dataVencimentoPrimeiraParcela.toDate()
        : dataVencimentoPrimeiraParcela
      : new Date()
  )

  useEffect(() => {
    const valorEntradaNumber = handleDecimalConvert(valorEntrada)
    const totalNumber =
      typeof totalPagamento === 'string' ? handleDecimalConvert(totalPagamento) : Number(totalPagamento)
    if (valorEntradaNumber >= formatFromMoney(totalPagamento)) {
      setValorEntrada(totalPagamento.substring(3))
      setParcelamento(parcelasSelect[0])
      return
    }

    const parcelasCalculadas = gerarParcelasPagamento({
      totalPagamento: totalNumber,
      valorEntradaNumber,
      numeroParcelas: parcelamentoSelecionado.value,
      dataVencimento,
    })

    setPagamento &&
      setPagamento({
        ...pagamento,
        parcelas: parcelasCalculadas,
        valorTotal: totalNumber,
        dataVencimento: dataVencimento,
        numeroParcelas: parcelasCalculadas.length,
      })
    setParcelas(parcelasCalculadas)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valorEntrada, totalPagamento, parcelamentoSelecionado, dataVencimento])
  const handleChangeCurrency = (currency) => setTotalPagamento(currency)

  const handleDataVencimento = (data) => {
    if (moment() > data) {
      data = moment()
    }
    setVencimento(data)
  }

  const setParcelamento = (parcelas) => setParcelamentoSelecionado(parcelas)

  const setVencimento = (vencimento) => {
    setDataVencimento(vencimento)

    if (setDataVencimentoPrimeiraParcela) {
      setDataVencimentoPrimeiraParcela(vencimento)
    }
  }

  return (
    <div className='d-flex'>
      <Container className='pb-5' style={{ maxWidth: 750 }}>
        <Fragment>
          <h4 className='my-4 text-secondary font-weight-bold'>Condições de pagamento</h4>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Valor Total</Form.Label>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>R$</InputGroup.Text>
                </InputGroup.Prepend>
                <CurrencyInput
                  className='form-control'
                  decimalSeparator=','
                  thousandSeparator='.'
                  value={totalPagamento}
                  onChange={handleChangeCurrency}
                  disabled={!isPlanoBalao}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} className='col-md-2'>
              <Form.Label>Parcelas</Form.Label>
              <Select value={parcelamentoSelecionado} options={parcelasSelect} onChange={setParcelamento} />
            </Form.Group>
            <Form.Group as={Col} className='required'>
              <Form.Label>Data da Primeira parcela</Form.Label>
              <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br'>
                <KeyboardDatePicker
                  invalidDateMessage='A data deve ser a partir de hoje'
                  minDateMessage='A data deve ser a partir de hoje'
                  id='dataPrimeiraParcela'
                  name='dataPrimeiraParcela'
                  className='form-control'
                  onChange={handleDataVencimento}
                  value={dataVencimento}
                  variant='inline'
                  format='DD/MM/YYYY'
                  required
                  animateYearScrolling
                  disablePast
                />
              </MuiPickersUtilsProvider>
            </Form.Group>
          </Row>
          {valorParcelamento <= handleDecimalConvert(totalPagamento) && (
            <div>
              <h4 className='my-4 text-secondary font-weight-bold'>Resumo do Parcelamento</h4>
              <Table bordered hover>
                <thead>
                  <tr>
                    <th className='text-center' width='100px'>
                      Parcela
                    </th>
                    <th className='text-center'>Vencimento</th>
                    <th className='text-center' width='250px'>
                      Valor
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {parcelas.map(({ numero, dataVencimento, valor }, index) => (
                    <tr key={index}>
                      <td className='text-center'>{numero}</td>
                      <td className='text-center'>
                        {dataVencimento ? moment(dataVencimento).format(`DD/MM/YYYY`) : 'Data Inválida'}
                      </td>
                      <td className='text-center'>{formatMoney(valor)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className='d-flex justify-content-end'>
                {previousStep && (
                  <Button className='mt-3 d-block' onClick={previousStep} variant='outline-primary'>
                    Cancelar
                  </Button>
                )}
                {handlePlanoPagamento && (
                  <Button className='mt-3 ml-2 d-block' onClick={handlePlanoPagamento} variant='primary'>
                    Salvar Plano
                  </Button>
                )}
              </div>
            </div>
          )}
        </Fragment>
      </Container>
    </div>
  )
}
